'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTransitionGroup = require('react-transition-group');

var _nextUtilNew = require('./next-util-new');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noop = function noop() {};
var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];

function getStyleProperty(node, name) {
    var style = window.getComputedStyle(node);
    var ret = '';
    for (var i = 0; i < prefixes.length; i++) {
        ret = style.getPropertyValue(prefixes[i] + name);
        if (ret) {
            break;
        }
    }
    return ret;
}

var AnimateChild = function (_Component) {
    (0, _inherits3.default)(AnimateChild, _Component);

    function AnimateChild(props) {
        (0, _classCallCheck3.default)(this, AnimateChild);

        var _this2 = (0, _possibleConstructorReturn3.default)(this, (AnimateChild.__proto__ || (0, _getPrototypeOf2.default)(AnimateChild)).call(this, props));

        (0, _nextUtilNew.bindCtx)(_this2, ['handleEnter', 'handleEntering', 'handleEntered', 'handleExit', 'handleExiting', 'handleExited', 'addEndListener']);
        _this2.endListeners = {
            transitionend: [],
            animationend: []
        };
        return _this2;
    }

    (0, _createClass3.default)(AnimateChild, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            var _this3 = this;

            (0, _keys2.default)(this.endListeners).forEach(function (eventName) {
                _this3.endListeners[eventName].forEach(function (listener) {
                    (0, _nextUtilNew.off)(_this3.node, eventName, listener);
                });
            });
            this.endListeners = {
                transitionend: [],
                animationend: []
            };
        }
    }, {
        key: 'generateEndListener',
        value: function generateEndListener(node, done, eventName) {
            var _this = this;
            return function endListener(e) {
                if (e && e.target === node) {
                    if (this.endTimeout) {
                        clearTimeout(this.endTimeout);
                    }

                    done();
                    (0, _nextUtilNew.off)(node, eventName, endListener);
                    var listeners = _this.endListeners[eventName];
                    var index = listeners.indexOf(endListener);
                    index > -1 && listeners.splice(index, 1);
                }
            };
        }
    }, {
        key: 'addEndListener',
        value: function addEndListener(node, done) {
            if (_nextUtilNew.support.transition || _nextUtilNew.support.animation) {
                this.node = node;
                if (_nextUtilNew.support.transition) {
                    var transitionEndListener = this.generateEndListener(node, done, 'transitionend');
                    (0, _nextUtilNew.on)(node, 'transitionend', transitionEndListener);
                    this.endListeners.transitionend.push(transitionEndListener);
                }
                if (_nextUtilNew.support.animation) {
                    var animationEndListener = this.generateEndListener(node, done, 'animationend');
                    (0, _nextUtilNew.on)(node, 'animationend', animationEndListener);
                    this.endListeners.animationend.push(animationEndListener);
                }

                var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
                var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
                var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
                var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
                var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
                this.endTimeout = setTimeout(function () {
                    done();
                }, time * 1000 + 200);
            } else {
                done();
            }
        }
    }, {
        key: 'removeEndtListener',
        value: function removeEndtListener() {
            this.transitionOff && this.transitionOff();
            this.animationOff && this.animationOff();
        }
    }, {
        key: 'removeClassNames',
        value: function removeClassNames(node, names) {
            (0, _keys2.default)(names).forEach(function (key) {
                (0, _nextUtilNew.removeClass)(node, names[key]);
            });
        }
    }, {
        key: 'handleEnter',
        value: function handleEnter(node, isAppearing) {
            var names = this.props.names;

            if (names) {
                this.removeClassNames(node, names);
                var className = isAppearing ? 'appear' : 'enter';
                (0, _nextUtilNew.addClass)(node, names[className]);
            }

            var hook = isAppearing ? this.props.onAppear : this.props.onEnter;
            hook(node);
        }
    }, {
        key: 'handleEntering',
        value: function handleEntering(node, isAppearing) {
            var _this4 = this;

            setTimeout(function () {
                var names = _this4.props.names;

                if (names) {
                    var className = isAppearing ? 'appearActive' : 'enterActive';
                    (0, _nextUtilNew.addClass)(node, names[className]);
                }

                var hook = isAppearing ? _this4.props.onAppearing : _this4.props.onEntering;
                hook(node);
            }, 10);
        }
    }, {
        key: 'handleEntered',
        value: function handleEntered(node, isAppearing) {
            var names = this.props.names;

            if (names) {
                var classNames = isAppearing ? [names.appear, names.appearActive] : [names.enter, names.enterActive];
                classNames.forEach(function (className) {
                    (0, _nextUtilNew.removeClass)(node, className);
                });
            }

            var hook = isAppearing ? this.props.onAppeared : this.props.onEntered;
            hook(node);
        }
    }, {
        key: 'handleExit',
        value: function handleExit(node) {
            var names = this.props.names;

            if (names) {
                this.removeClassNames(node, names);
                (0, _nextUtilNew.addClass)(node, names.leave);
            }

            this.props.onExit(node);
        }
    }, {
        key: 'handleExiting',
        value: function handleExiting(node) {
            var _this5 = this;

            setTimeout(function () {
                var names = _this5.props.names;

                if (names) {
                    (0, _nextUtilNew.addClass)(node, names.leaveActive);
                }
                _this5.props.onExiting(node);
            }, 10);
        }
    }, {
        key: 'handleExited',
        value: function handleExited(node) {
            var names = this.props.names;

            if (names) {
                [names.leave, names.leaveActive].forEach(function (className) {
                    (0, _nextUtilNew.removeClass)(node, className);
                });
            }

            this.props.onExited(node);
        }
    }, {
        key: 'render',
        value: function render() {
            /* eslint-disable no-unused-vars */
            var _props = this.props,
                names = _props.names,
                onAppear = _props.onAppear,
                onAppeared = _props.onAppeared,
                onAppearing = _props.onAppearing,
                onEnter = _props.onEnter,
                onEntering = _props.onEntering,
                onEntered = _props.onEntered,
                onExit = _props.onExit,
                onExiting = _props.onExiting,
                onExited = _props.onExited,
                others = (0, _objectWithoutProperties3.default)(_props, ['names', 'onAppear', 'onAppeared', 'onAppearing', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited']);
            /* eslint-enable no-unused-vars */

            return _react2.default.createElement(_reactTransitionGroup.Transition, (0, _extends3.default)({}, others, {
                onEnter: this.handleEnter,
                onEntering: this.handleEntering,
                onEntered: this.handleEntered,
                onExit: this.handleExit,
                onExiting: this.handleExiting,
                onExited: this.handleExited,
                addEndListener: this.addEndListener }));
        }
    }]);
    return AnimateChild;
}(_react.Component);

AnimateChild.propTypes = {
    names: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
    onAppear: _propTypes2.default.func,
    onAppearing: _propTypes2.default.func,
    onAppeared: _propTypes2.default.func,
    onEnter: _propTypes2.default.func,
    onEntering: _propTypes2.default.func,
    onEntered: _propTypes2.default.func,
    onExit: _propTypes2.default.func,
    onExiting: _propTypes2.default.func,
    onExited: _propTypes2.default.func
};
AnimateChild.defaultProps = {
    onAppear: noop,
    onAppearing: noop,
    onAppeared: noop,
    onEnter: noop,
    onEntering: noop,
    onEntered: noop,
    onExit: noop,
    onExiting: noop,
    onExited: noop
};
exports.default = AnimateChild;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-slider-bar-nav@0.0.38@@alicd/crui-slider-bar-nav/lib/NextAnimateChild.js
// module id = 750
// module chunks = 0